import UmiLogger from './UmiLogger';

const Logger = new UmiLogger('Landbot');
window.landbotLogger = Logger;

export default Logger;


// WEBPACK FOOTER //
// ../UmiCore/src/Logger.js